import React from 'react';

import { CreateOrgUnit } from 'presentation/pages';

export const MakeCreateOrgUnitFactory: React.FC = () => {
  return <CreateOrgUnit />;
};
